<template>
  <v-dialog v-model="shown" width="500">
    <v-card class="rsvp-list-modal-card">
      <v-card-title class="primary white--text rsvp-list-modal-header">
        <span class="text-h6">RSVPs {{ authors.length ? `(${rsvpTotal})` : '' }}</span>
        <v-spacer />
        <v-btn icon dark @click="shown = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="rsvp-list-modal-body pt-4">
        <template v-if="event && authors.length">
          <p class="mb-2">{{ event.description || 'Event' }}</p>
          <v-list dense class="rsvp-list">
            <v-list-item
              v-for="entry in sortedAuthors"
              :key="entry.authorId"
              class="rsvp-list-item"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ authorName(entry.authorId) }}{{ entry.hasPlusOne ? ' (+1)' : '' }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
        <p v-else class="grey--text">No authors have RSVPed for this event.</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TheRsvpListModal',
  data: () => ({
    shown: false,
    event: null,
    authors: []
  }),
  computed: {
    ...mapGetters(['authorById']),
    /** Total count: 1 per author + 1 per plus-one. */
    rsvpTotal () {
      if (!this.authors || !this.authors.length) return 0
      return this.authors.reduce((sum, a) => sum + 1 + (a.hasPlusOne ? 1 : 0), 0)
    },
    /** Authors sorted alphabetically by last name, then first name. */
    sortedAuthors () {
      if (!this.authors || !this.authors.length) return []
      return [...this.authors].sort((a, b) => {
        const authorA = this.authorById(a.authorId)
        const authorB = this.authorById(b.authorId)
        const lastA = (authorA && authorA.lastName) || (authorA && authorA.fullName) || a.authorId || ''
        const lastB = (authorB && authorB.lastName) || (authorB && authorB.fullName) || b.authorId || ''
        const cmp = lastA.localeCompare(lastB, undefined, { sensitivity: 'base' })
        if (cmp !== 0) return cmp
        const firstA = (authorA && authorA.firstName) || ''
        const firstB = (authorB && authorB.firstName) || ''
        return firstA.localeCompare(firstB, undefined, { sensitivity: 'base' })
      })
    }
  },
  mounted () {
    this.$root.$on('showRsvpListModal', ({ event, authors }) => {
      this.event = event
      this.authors = authors || []
      this.shown = true
    })
  },
  methods: {
    authorName (authorId) {
      const author = this.authorById(authorId)
      return author ? author.fullName : authorId
    }
  }
}
</script>

<style lang="scss" scoped>
.rsvp-list-modal-card {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
}

.rsvp-list-modal-header {
  flex-shrink: 0;
}

.rsvp-list-modal-body {
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
}
</style>

<style lang="scss">
/* Non-scoped so we can override Vuetify's .v-list-item min-height */
.rsvp-list-modal-body .v-list-item,
.rsvp-list-modal-body .v-list-item.v-list-item--dense {
  min-height: 0 !important;
}
.rsvp-list-modal-body .v-list-item__content {
  padding: 4px !important;
}
</style>
